module.exports = __webpack_public_path__ + "img/smartgoals_logo.fa082816.png";